import { render } from "./CustomerDashboard.html?vue&type=template&id=554900f3&scoped=true&external"
import script from "./CustomerDashboard.js?vue&type=script&lang=js&external"
export * from "./CustomerDashboard.js?vue&type=script&lang=js&external"

import "./CustomerDashboard.vue?vue&type=style&index=0&id=554900f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554900f3"]])

export default __exports__